export default "__VITE_ASSET__CE28Yq9e__"